import { apiRequest } from "@/network/apiClient";
import { useState,useEffect } from "react";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useGetReferrerList = () =>{
    const [referrerList, setReferrerList] = useState([])

    const fetchData = async () =>{
        try{
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.AUTH.REFERRER_LIST}`, 'GET')
            setReferrerList(result)
        }catch (error){
            console.error('Error fetching data: ', error)
        }
    };

    useEffect(() =>{
        fetchData();
    },[]);

    return referrerList
}